import typeDefs from './typeDefs';

export { default as typeDefs } from './typeDefs';

export default {
  typeDefs,
};
